import axios from 'axios';
import { useToastStore } from '@/stores/toastStore';
import router from '@/router';

const SESSION_TOAST_KEY = 'session_toast_shown';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Interceptor para adicionar o token Authorization automaticamente
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    const tenantJson = localStorage.getItem('tenant');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    if (tenantJson) {
        try {
            const tenant = typeof tenantJson === 'string' ? JSON.parse(tenantJson) : tenantJson;
            if (tenant && tenant.id) {
                config.headers['X-Tenant-Id'] = `${tenant.id}`;
            }
        } catch (e) {
            // ignore parsing errors
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// Interceptor for responses to handle common errors
axiosInstance.interceptors.response.use((response) => {
    return response;
}, (error) => {
    const toastStore = useToastStore();

    if (error.response) {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            // avoid showing many toasts when multiple requests fail at once
            if (!localStorage.getItem(SESSION_TOAST_KEY)) {
                localStorage.setItem(SESSION_TOAST_KEY, '1');
                toastStore.error('Sessão expirada. Por favor, faça login novamente.');
            }
            router.push('/login');
        } else if (error.response.status === 500) {
            toastStore.error('Erro interno do servidor. Tente novamente mais tarde.');
        } else if (error.response.status === 402) {
            // Assinatura vencida: o painel fica só para consulta
            toastStore.warning(error.response.data?.message || 'Sua assinatura venceu.');
        } else if (error.response.status === 403) {
            // Limite ou recurso fora do plano: mostra a mensagem do backend
            toastStore.error(error.response.data?.upgrade_required ? error.response.data.message : 'Acesso negado.');
        }
    } else if (error.request) {
        toastStore.error('Não foi possível conectar ao servidor. Verifique sua conexão.');
    }

    return Promise.reject(error);
});

export default axiosInstance;